import React from "react";
import { useTranslation } from "react-i18next";
import "./pupop.scss";

export const Pupop = ({ setShowPupop, pupopTitle }) => {
  const {t} = useTranslation();
  const isOkHanlder = () => {
    setShowPupop && setShowPupop(false);
  };
  return (
    <>
      <div className="pupop-container">
        <h2 className="pupop-header"></h2>
        <p className="pupop-text">{t(pupopTitle)}</p>
        <button className="isOk" onClick={isOkHanlder}>
          {t("确认")}
        </button>
      </div>
    </>
  );
};